import { CommonModule } from '@angular/common';
import { Component, inject, viewChild, ViewEncapsulation } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { PagesService } from '@services/pages.service';
import { SharedService } from '@services/shared.service';
import { LanguageService } from '@services/language.service';
import { SafeHtmlPipe } from 'src/app/pipes/safe-html.pipe';
import { decodeEscapedHtml, filterHtmlContentByLanguage } from 'src/app/utils/arabic-pdf.util';

@Component({
  selector: 'app-privacy-policy',
   standalone: true,
  imports: [TranslateModule, CommonModule, SafeHtmlPipe],
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss'],

})
export class PrivacyPolicyComponent {
  isOuterRoute = false;
  privacyData: any;
  displayContent = '';
  SafeHtmlPipe!: SafeHtmlPipe;
  pageService = inject(PagesService)
  sharedService = inject(SharedService);
  languageService = inject(LanguageService);


  constructor() { }
  ngOnInit(): void {
    const hash = window.location.hash;
    const path = hash.replace(/^#/, '');
    this.isOuterRoute = path === '/privacy-policy';

    this.loadPrivacyPolicy();
    this.languageService.currentLanguage$.subscribe(() => this.updateDisplayContent());
  }

  loadPrivacyPolicy() {
    // Loader show kar do
    this.sharedService.showLoader();

    this.pageService.getAll('GET_PRIVACY_POLICY').subscribe({
      next: (res: any) => {
        if (res && res.length > 0) {
          this.privacyData = res[0];
          this.updateDisplayContent();
        }
      },
      error: (err: any) => {
        console.error('Failed to load privacy policy', err);
        // Agar error aaye to bhi loader hide kar do
        this.sharedService.hideLoader();
      },
      complete: () => {
        // Request complete hone par loader hide kar do
        this.sharedService.hideLoader();
      }
    });
  }

  private updateDisplayContent(): void {
    if (!this.privacyData?.content) return;
    const lang = localStorage.getItem('lang') || 'en';
    // Decode first: the language filter splits on <h2>, which stays invisible
    // while the markup is still entity-escaped.
    this.displayContent = filterHtmlContentByLanguage(decodeEscapedHtml(this.privacyData.content), lang);
  }

}